import * as React from 'react';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const label = { inputProps: { 'aria-label': 'Color switch demo' } };

// Styled Switch for custom background color
const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#ffffff', // Thumb color when checked
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#495a69',
    opacity:1,// Background color when checked
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#ccc', // Background color when unchecked
    opacity:1
  },
}));

export default function MuiToggleSwitch() {
  return (
    <div>
      <CustomSwitch {...label} defaultChecked />
    </div>
  );
}